import AppLink from "components/app-link-view";

export default AppLink;
